var _defs, _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _circle4, _circle5, _path5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryGuide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 280,
    viewBox: "0 0 220 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "robe",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7bd8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4fb7c5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 280,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 70,
    r: 46,
    fill: "#ffd9b8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 62,
    r: 6,
    fill: "#6b4f3f"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 62,
    r: 6,
    fill: "#6b4f3f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 84 Q110 100 130 84",
    stroke: "#6b4f3f",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42 Q110 10 160 42",
    fill: "#7a5c4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48 Q110 18 168 48",
    fill: "#6b4f3f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 130 Q110 110 160 130 L176 220 Q110 250 44 220 Z",
    fill: "url(#robe)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 150,
    r: 14,
    fill: "#ffd9b8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 150,
    r: 14,
    fill: "#ffd9b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 190 Q110 210 130 190",
    stroke: "#ffffff",
    strokeWidth: 6,
    fill: "none",
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 214,
    r: 8,
    fill: "#ffffff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 214,
    r: 8,
    fill: "#ffffff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 214,
    r: 4,
    fill: "#ff7aa2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 214,
    r: 4,
    fill: "#ff7aa2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryGuide);
export default __webpack_public_path__ + "static/media/story-guide.b9061a7784d09b0c2102ec53de5c5d6f.svg";
export { ForwardRef as ReactComponent };